import {TriggerParams} from './TriggerParams';

export enum Visibility {
  Open = 'open',
  Minimized = 'minimized',
  Closed = 'closed',
}

export interface InitialVisibility {
  visibility: Visibility;
  triggerParams?: TriggerParams;
}
